<template>
  <div class="categoryBubble">
    <div v-if="senderType === 'USER'">
      {{ jsonContent.text }}
    </div>
    <div v-else class="categoryBox">
      <dl>
        <dt v-html="jsonContent.text"></dt>
        <dd v-for="(item, index) in jsonContent.buttons" :key="index" @click="clickedCategory(item)" :disabled="loading">
          <div>{{ item.data }}</div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Util from '@/util'
import Uuid from 'vue-uuid'
import eventBus from '@/event_bus'

export default {
  name: 'message_category',
  props: [
    'brandKey', 'chatRoomId', 'content', 'senderType'
  ],
  data () {
    return {
      uuid: Uuid.v1,
      jsonContent: '',
      loading: false
    }
  },
  created () {
    this.jsonContent = JSON.parse(this.content)
  },
  methods: {
    getSenderUid () {
      let sid = Util.getLoginIdParam() ? Util.getLoginIdParam() : Util.getSenderUid()
      if (!sid) {
        sid = this.$uuid.v1()
        Util.setSenderUid(sid)
      }
      return sid
    },
    clickedCategory (item) {
      // 필수 값이 존재하지 않는 경우, 이벤트를 막도록 한다.
      if (this.brandKey === undefined || this.chatRoomId === undefined) return

      if (item.type === 'URL') {
        if (item.data === '利用規約を見る') {
          window.open(item.code, 'urlWindow', 'toolbar=no,menubar=no,resizeable=1,width=400,height=300')
          return
        } else {
          window.open(item.pcUrl || item.mobileUrl, 'urlWindow', 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=yes')
          return
        }
      }

      let content = {text: item.data, code: item.code}

      this.loading = true
      this.axios.post('/api/external/webchat/sendMessage', {
        brandKey: this.brandKey,
        senderUid: this.getSenderUid(),
        chatRoomId: this.chatRoomId,
        messageType: 'COMBINATION',
        content: JSON.stringify(content)
      }).then(res => {
        if (res.data.code === -12000) {
          eventBus.$emit('invalid-chat-room-customer')
        }
      }, () => this.$alertMsg('メッセージ転送中に問題が発生しました。'))
        .catch(errorMsg => console.log(errorMsg))
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .categoryBubble .categoryBox dl dd {
    background-color: #F8FAFF;
    border: 0.5px solid $gray-4;

    > div {
      color: #ff8d8d;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/message_category.vue